import { Button, Stack, Typography } from '@mui/material';
import { useRef } from 'react';
import { IDocument } from '../../../../Interfaces/IDocument';

function fileToBase64(file: File): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onerror = () => reject(new Error('Failed to read file'));
    reader.onload = () => {
      const result = reader.result;
      if (typeof result !== 'string') {
        reject(new Error('Unexpected FileReader result type'));
        return;
      }
      // result is a Data URL like: "data:application/pdf;base64,AAAA..."
      // If your backend wants *only* the base64 part, strip the prefix:
      const base64 = result.split(',')[1] ?? '';
      resolve(base64);
    };
    reader.readAsDataURL(file);
  });
}

function DocumentInfo({ doc }: { doc: IDocument }) {
  return (
    <Stack>
      <span>{doc.FileName}</span>
    </Stack>
  );
}

type RelationshipDocumentUploadProps = {
  documents: IDocument[];
  setDocuments: React.Dispatch<React.SetStateAction<IDocument[]>>;
};

export function RelationshipDocumentUpload({
  documents,
  setDocuments,
}: RelationshipDocumentUploadProps) {
  const inputRef = useRef<HTMLInputElement | null>(null);

  const onPick: React.ChangeEventHandler<HTMLInputElement> = async e => {
    const file = e.target.files?.[0] ?? null;
    if (!file) return;

    const base64Data = await fileToBase64(file);

    const newDocument: IDocument = {
      idDocument: -Date.now(), // Assign appropriate ID as needed
      FileName: file.name,
      idMIMEType: 0, // Assign appropriate MIME type ID as needed
      Data: base64Data,
    };

    setDocuments(prevDocs => [...prevDocs, newDocument]);

    // allows re-selecting the same file and still firing onChange
    e.target.value = '';
  };

  return (
    <Stack spacing={1}>
      <input
        ref={inputRef}
        hidden
        type='file'
        accept='.pdf,.doc,.docx,image/*'
        onChange={onPick}
      />

      <Stack
        direction='row'
        spacing={1}
        alignItems='center'
        justifyContent={'space-between'}
      >
        <Typography variant='h6'>Hochgeladene Dokumente</Typography>
        <Button variant='contained' onClick={() => inputRef.current?.click()}>
          Dokument hochladen
        </Button>
      </Stack>
    </Stack>
  );
}
